<script setup>
import InputText  from "@/components/form/InputText.vue";
import RadioGroup from "@/components/contract-detail/CovercardRadioGroup.vue";
const props = defineProps({
  emailStorePraxisSoftwareSelect: undefined,
  errors: Object,
  inputs: Object,
  inputOptions: Object,
  language: "",
  validators: Object,
});

</script>

<template>
  <div>
    <p>{{ $t("furtherInformation.cardReaderOrder") }}</p>
    <RadioGroup
      name="cardReader"
      :language
      v-model:selectedValue="inputs.cardReader"
      :options="inputOptions.cardReaderOrder"
      topic="cardReaderOrder"
    />
    <InputText
      name="practiceSoftware"
      class="margin"
      :label="$t('furtherInformation.practiceSoftware')"
      v-model="inputs.practiceSoftware"
      :error="errors.practiceSoftware"
      :readonly="emailStorePraxisSoftwareSelect?.key
        && emailStorePraxisSoftwareSelect?.key !== 'no-software' ? true : false"
    />
    <small id="inputTextHelp" class="form-text text-muted">
      <i18n-t keypath="contractDetail.inputs.cardReaderInfoText" tag="p" scope="global">
        <template v-slot:cardReaderHere>
          <a class="text-primary" target="_blank" rel="noreferrer noopener nofollow" :href="$t('contractDetail.inputs.cardReaderlink')">{{ $t("contractDetail.inputs.cardReaderHere") }}</a>
        </template>
      </i18n-t>
    </small>
  </div>
</template>

<style scoped>
.margin {
  margin-bottom: 0.25rem;
}
</style>
